import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PowerBiDashboardComponent } from './powerbi-dashboard/powerbi-dashboard.component';
import { PowerBiReportViewerComponent } from './powerbi-report-viewer/powerbi-report-viewer.component';

@NgModule({
  declarations: [PowerBiDashboardComponent, PowerBiReportViewerComponent],
  imports: [CommonModule],
  exports: [PowerBiDashboardComponent, PowerBiReportViewerComponent],
})
export class PowerBiModule {}
